import { __assign } from "tslib";
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { customFormatters } from './customFormatters';
import lazyi18nextBackend from './lazyI18nextBackend';
import ReactPostprocessor from 'i18next-react-postprocessor';
/**
 * This is the default i18next config used by frontend projects
 *
 * You can provide either single resource or a map of ns to resources
 */
export default function i18n(_a, debug) {
    var _b;
    var locale = _a.locale, resources = _a.resources, _c = _a.options, options = _c === void 0 ? {} : _c;
    var res = (_b = {}, _b[locale] = { translation: resources }, _b);
    // Allow NS resources to be passed
    if (resources.translation) {
        res[locale] = resources;
    }
    return i18next
        .use(initReactI18next)
        .use(lazyi18nextBackend())
        .use(new ReactPostprocessor())
        .use(customFormatters)
        .init(__assign({ partialBundledLanguages: true, keySeparator: '$', lng: locale, fallbackLng: 'en', debug: debug, interpolation: {
            escapeValue: false,
        }, resources: res }, options), undefined);
}
//# sourceMappingURL=presetI18nClientConfig.js.map